import { render, staticRenderFns } from "./CalendarioAcreditaciones.vue?vue&type=template&id=0233c714&"
import script from "./CalendarioAcreditaciones.vue?vue&type=script&lang=js&"
export * from "./CalendarioAcreditaciones.vue?vue&type=script&lang=js&"
import style0 from "./CalendarioAcreditaciones.vue?vue&type=style&index=0&id=0233c714&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports